import React, { useState } from "react";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { AddEditTask, TaskList } from "../../components/task";
import { CREATE_TASK } from "../../constants";
import { useHasPermission } from "../../utils";

export const Task = () => {
  const [open, setOpen] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [reload, setReload] = useState(0);

  const hasTaskCreate = useHasPermission(CREATE_TASK);

  const reloadTasks = () => setReload((prev) => prev + 1);

  const buttons = [
    hasTaskCreate && {
      buttonText: "Add Task",
      buttonIcon: Add,
      onClick: () => setOpen(true),
    },
  ];
  return (
    <>
      <PageLayout>
        {/* header section */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <PageHeader
            // title
            title="Task"
            subtitle={`${totalCount} tasks`}
            // button
            buttons={buttons}
          />
        </Box>

        {/* details */}
        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <TaskList totalCount={totalCount} setTotalCount={setTotalCount} reloadData={reload} />
        </Box>
      </PageLayout>

      {/* add task */}
      <AddEditTask open={open} onClose={() => setOpen(false)} onSuccess={reloadTasks} />
    </>
  );
};
